import type { ReposicionPdfDocument } from '../../domain/ReposicionPdfModel.ts';
import type { ReposicionPdfPort } from '../../domain/ports/ReposicionPdfPort.ts';
import { loadReposicionPdfTemplateBytes } from '@src/modules/platform/pdf/pdfTemplateSources.ts';
import { renderReposicionPdfFromTemplate } from './reposicionPdfTemplateRenderer.ts';

export class BrowserReposicionPdfAdapter implements ReposicionPdfPort {
  async generate(model: ReposicionPdfDocument): Promise<Blob> {
    const templateBytes = await loadReposicionPdfTemplateBytes();
    const pdfBytes = await renderReposicionPdfFromTemplate(templateBytes, model);
    return new Blob([Uint8Array.from(pdfBytes)], { type: 'application/pdf' });
  }
}
